module.exports = "images/slash.d2a1e1af.png";